import { Input } from ".";
import React from "react";

export const InputEmail = props => {
    return <Input {...props} type='email' />;
};
